import {observer} from "mobx-react-lite";
import React from "react";
import {useTranslation} from "react-i18next";
import {EventTemplateDuration} from "../../../stores/domainStore/pages/models/eventTemplateDuration";
import NumberBox from "../../atoms/input/numberBox";
import EditField from "../../molecules/editField/editField";
import "./eventTemplateDurationEdit.scss";

export interface IEventTemplateDurationEditProps {
  eventTemplateDuration: EventTemplateDuration;
}

const EventTemplateDurationEdit: React.FC<IEventTemplateDurationEditProps> = ({
  eventTemplateDuration
}) => {
  const {t} = useTranslation(["eventTemplate"]);

  const getErrorMessage = () => {
    // To check if the user enters invalid minutes value like 1234
    if (!eventTemplateDuration.minutes.isValid) {
      return t("eventTemplate:errors.invalidDuration");
    } else if (eventTemplateDuration.isSelectedTimeExceedMaxAllowedTime) {
      return t("eventTemplate:errors.exceedsMaxDuration", {
        maxDuration: "4 hrs"
      });
    } else if (eventTemplateDuration.isSelectedTimeBelowMinAllowedTime) {
      return t("eventTemplate:errors.selectDuration");
    }

    return t("eventTemplate:errors.invalidDuration");
  };

  return (
    <EditField
      label={t("eventTemplate:labels.duration")}
      validationMessage={getErrorMessage()}
      showValidationMessage={!eventTemplateDuration.isValid}
      isRequired={true}
    >
      <div className="mr-3 duration-hours">
        <NumberBox
          value={eventTemplateDuration.hours}
          postfix={t("eventTemplate:labels.durationHoursUnit")}
        />
      </div>
      <div className="duration-minutes">
        <NumberBox
          value={eventTemplateDuration.minutes}
          postfix={t("eventTemplate:labels.durationMinutesUnit")}
          step={15}
        />
      </div>
    </EditField>
  );
};

export default observer(EventTemplateDurationEdit);
